import React from 'react';
import { getPrivacyInfo } from '../utils/PrivacyUtils';

/**
 * 隐私标识徽章
 * 用于在页面上标注某个功能的数据处理方式
 * 
 * @param {string} type - 隐私类型: 'bazi_calc' | 'ai_feature' | 'local_analysis' | 'bazi_storage' | 'partner_match'
 * @param {boolean} compact - 紧凑模式（仅图标+文字，无描述）
 * @param {string} className - 额外样式
 */
function PrivacyBadge({ type = 'local_analysis', compact = false, className = '' }) {
  const info = getPrivacyInfo(type);
  
  if (compact) {
    return (
      <span className={`inline-flex items-center gap-1 text-[10px] sm:text-xs rounded-full px-2 py-0.5 ${
        info.level === 'external' 
          ? 'bg-blue-50 text-blue-600' 
          : 'bg-green-50 text-green-600'
      } ${className}`}>
        <span>{info.icon}</span>
        <span>{info.label}</span>
      </span>
    );
  }

  return (
    <div className={`flex items-start gap-2 rounded-xl p-3 text-xs ${
      info.level === 'external'
        ? 'bg-blue-50 border border-blue-100'
        : 'bg-green-50 border border-green-100'
    } ${className}`}>
      <span className="text-base flex-shrink-0 mt-0.5">{info.icon}</span>
      <div>
        <span className={`font-medium ${info.level === 'external' ? 'text-blue-700' : 'text-green-700'}`}>
          {info.label}
        </span>
        <p className={`mt-0.5 leading-relaxed ${info.level === 'external' ? 'text-blue-600/80' : 'text-green-600/80'}`}>
          {info.desc}
        </p>
      </div>
    </div>
  );
}

export default PrivacyBadge;
